import { InfoCircledIcon } from '@radix-ui/react-icons';
import { Flex, Text, Tooltip } from '@radix-ui/themes';
import { RX } from 'enums/radix';
import { FormInputDef } from 'interfaces/form/input';

export const FormLabel = (props: FormInputDef) => {
  if (props.hideLabel) {
    return null;
  }

  return (
    <Flex justify="between">
      <Text size="1" color={RX.CLR.NEUTRAL} truncate>
        {props.label}
      </Text>

      {props.tooltip && (
        <Tooltip content={props.tooltip}>
          <InfoCircledIcon color={RX.CLR.NEUTRAL} />
        </Tooltip>
      )}
    </Flex>
  );
};
